import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Terms() {
  return (
    <div className="container mx-auto px-4 md:px-8 py-12 max-w-3xl" data-testid="terms-page">
      <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-wider text-muted-foreground hover:text-foreground mb-8">
        <ArrowLeft className="w-4 h-4" /> Back
      </Link>
      <h1 className="font-heading text-4xl mb-2">TERMS OF SERVICE</h1>
      <p className="text-xs uppercase tracking-widest text-muted-foreground mb-2">Last updated: June 2026</p>
      <p className="text-xs uppercase tracking-widest text-muted-foreground mb-10">Operated by Life Admin Autofill · ABN 74 647 107 845 · support@lifeautofill.com · Governed by the laws of Australia</p>

      <div className="space-y-8 leading-relaxed">
        <Section title="THE DEAL">
          Life Admin Autofill ("we") provides a tool to store your personal/professional profile and auto-fill application forms. You ("you") agree to these terms by creating an account.
        </Section>
        <Section title="YOUR ACCOUNT">
          You're responsible for the accuracy of the data you store and for keeping your Google sign-in secure. One account per person.
        </Section>
        <Section title="ACCEPTABLE USE">
          Don't upload documents you don't have the right to upload. Don't use the service to commit fraud, identity theft, or to misrepresent yourself on applications. We may suspend accounts that violate these rules.
        </Section>
        <Section title="SUBSCRIPTION & BILLING">
          Pro access is $9.99/month, billed by Stripe. You can cancel anytime from your Settings — access continues until the end of the current billing period. We do not provide pro-rated refunds for partial months.
        </Section>
        <Section title="AI OUTPUT">
          Document parsing and autofill suggestions are generated by AI models. They are a starting point — always review the filled application before submitting. We are not liable for inaccuracies in AI extraction.
        </Section>
        <Section title="WARRANTY DISCLAIMER">
          The service is provided "as is" without warranty of any kind. To the maximum extent permitted by law, we are not liable for indirect or consequential damages.
        </Section>
        <Section title="CHANGES">
          We may update these terms. If we make material changes, we'll notify you by email or in-app banner before they take effect.
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-sm uppercase tracking-widest text-primary mb-3">{title}</h2>
      <p className="text-muted-foreground">{children}</p>
    </section>
  );
}
